import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import classes from './doctorScan.module.scss'
import { DoctorService } from '../../api/DoctorService'
import { useDispatch, useSelector } from 'react-redux'
import { ScanCompleted } from '../../store/reducers/ScanReducer/RegistrationScanReducer'
import { toast } from 'react-toastify'

const DoctorScan = ({onChange}) => {
    const {
        register,
        handleSubmit
    } = useForm()

    const [scan, setScan] = useState({
      "status": '',
      "quantityMaterial": '',
      "research": '',
      "id": '',
    })
    const [activeButton, setActiveButton] = useState('scan');

    const dispatch = useDispatch()
    const type = useSelector(state=>state.RegScan.ScanInputs)

    useEffect(()=>{
      if(type.type === 'change'){
        onChange({
          "status": type.status,
          "quantityMaterial": type.quantityMaterial,
          "research": type.research,
          "id": type.id,
          "type": type.type
        })
      }
    },[type])

    const onSubmit = async(data) =>{
      let id
      if(activeButton === 'scan'){
        id = (eval('({obj:' + data.resultsScan + '})')).obj?.directionId
      } else {
        id = data.resultsScan
      }
      try{
        
        await DoctorService.getDirection(id).then(res=>{
          if(res?.data){
            onChange({
              "id": id,
              "status": res?.data.status,
              "research": res?.data.research
            })
            setScan({
              "status": res?.data.status,
              "quantityMaterial": res?.data.quantityMaterial,
              "research": res?.data.research,
              "id": id
            })
          }
        })
      }catch (e){
        toast.error('Скануйте Qr-code!')
      }
      
    }

    useEffect(()=>{
      if (scan.research !== ''){
        dispatch(ScanCompleted({credential: scan}))
      }
    },[scan])

  return (
    <div className={classes.container}>
      <div>
        <button
          className={activeButton === 'scan' ? classes.selectButton__active : classes.selectButton}
          onClick={() => setActiveButton('scan')}
          type="button"
        >
          Сканування QR-code
        </button>
        <button
          className={activeButton === 'id' ? classes.selectButton__active : classes.selectButton}
          onClick={() => setActiveButton('id')}
          type="button"
        >
          Пошук за ID
        </button>
      </div>
      {activeButton === 'scan' &&
      <form className={classes.form} onSubmit={handleSubmit(onSubmit)}>
        <label className={classes.form__label}>Скануйте скерування</label>
        <input className={classes.form__input} placeholder='Скануйте QR-code' {...register('resultsScan')}/>
        <button className={classes.form__button} type='submit'>Продовжити</button>
      </form>
      }
      {activeButton === 'id' &&
        <form className={classes.form} onSubmit={handleSubmit(onSubmit)}>
          <label className={classes.form__label}>Введіть ID скерування</label>
          <input className={classes.form__input} placeholder='Введіть ID скерування' {...register('resultsScan')}/>
          <button className={classes.form__button} type='submit'>Продовжити</button>
        </form>
      }
    </div>
    
  )
}

export default DoctorScan